<template>
  <div class="stc-notification__content">
    <img
      :src="iconSrc"
      alt=""
      class="stc-notification__icon"
      :width="iconSize"
      :height="iconSize"
      :style="iconStyle"
    />

    <div class="stc-notification__text-container">
      <span v-if="displayTitle" class="stc-notification__title">{{ displayTitle }}</span>
      <span class="stc-notification__text">{{ description }}</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { StcNotificationType } from './types';

const ICONS_BASE =
  process.env.NODE_ENV === 'development'
    ? '/assets/images/icons'
    : '/local/templates/dist/assets/images/icons';

const NOTIFICATION_ICON_BY_TYPE: Record<StcNotificationType, string> = {
  error: `${ICONS_BASE}/error.svg`,
  success: `${ICONS_BASE}/share-icons/success-circle-icon.svg`,
  warning: `${ICONS_BASE}/triangle_warning_icon.svg`,
  info: `${ICONS_BASE}/information_circle.svg`,
};

const DEFAULT_TITLE_BY_TYPE: Record<StcNotificationType, string> = {
  error: 'Ошибка',
  success: 'Успешно',
  warning: 'Внимание',
  info: 'Информация',
};

const props = withDefaults(
  defineProps<{
    description: string;
    title?: string;
    type?: StcNotificationType;
    iconSize?: number;
  }>(),
  {
    type: 'error',
    iconSize: 24,
  },
);

const iconSrc = computed(() => NOTIFICATION_ICON_BY_TYPE[props.type]);
const iconStyle = computed(() => ({
  width: `${props.iconSize}px`,
  height: `${props.iconSize}px`,
}));
const displayTitle = computed(() => props.title ?? DEFAULT_TITLE_BY_TYPE[props.type]);
</script>
